import { jsx as r, jsxs as m } from "react/jsx-runtime";
import { useBreakpointValue as c, HStack as p } from "@chakra-ui/react";
import { Typography as s } from "../../dataDisplay/Typography/Typography.mjs";
import { Link as f } from "../Link/Link.mjs";
import { DefaultBranding as l } from "./branding/DefaultBranding.mjs";
import { MySgiBranding as d } from "./branding/MySgiBranding.mjs";
const B = ({ brandAs: i, brand: o, brandUrl: a, logo: e, brandVariant: n }) => {
  const t = c({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ r(f, { href: a, as: i, textDecoration: "none", color: "gray.800", children: /* @__PURE__ */ m(p, { spacing: 3, children: [
    e || (n === "mysgi" ? /* @__PURE__ */ r(d, {}) : /* @__PURE__ */ r(l, {})),
    o && !t && /* @__PURE__ */ r(
      s,
      {
        variant: "subheading1",
        textDecoration: "none",
        color: "gray.800",
        whiteSpace: "nowrap",
        children: o
      }
    )
  ] }) });
};
export {
  B as Brand
};
